/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const holidaySchemePatchRequestSchema = z.object({
  description: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  locationIds: z.array(z.int().nullable()).nullish(),
  name: z.string().nullish(),
});
